<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">宠物店名称:</div>
                <el-input v-model="conditionData.petShop" size="small" placeholder="请输入宠物店名称"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" size="small" icon="el-icon-download" @click="downloadExcel">导出数据</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="petShop"
                label="宠物店名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="宠物店联系电话"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="contacts"
                label="宠物店联系人"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="宠物店地区"
                align="center"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.province}}</span>
                    <span>{{scope.row.city}}</span>
                    <span>{{scope.row.area}}</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="address"
                label="宠物店详细地址"
                align="center"
                width="400px"
                >
                </el-table-column>

                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deletePetShop(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" :title="title" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        角色名称:
                    </div>
                    <el-input v-model="addData.name" size="small" placeholder="请输入角色名称"></el-input>
                </div>
                <div class="item">
                    <div class="label">
                        角色编码:
                    </div>
                    <el-input v-model="addData.code" size="small" placeholder="请输入角色编码"></el-input>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAddDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addRole">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" :title="title" width="900px">
            <div class="dialog" v-if="isUpdateDialog">
                <div class="item">
                    <div class="label">
                        宠物店名称:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.petShop" size="small" placeholder="请输入角色名称"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        宠物店联系电话:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.phone" size="small" placeholder="请输入角色编码"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        宠物店联系人:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.contacts" size="small" placeholder="请输入角色编码"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        宠物店地区:
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="addressList"
                        @change="handleAddRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        宠物店详细地址:
                    </div>
                    <div class="value">
                        <el-input v-model="updateData.address" size="small" placeholder="请输入角色编码"></el-input>
                    </div>
                </div>
                <div style="width:100%;margin-top:10px">
                    <el-table
                        :data="updateData.projectPrices"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width: 100%">
                        <el-table-column
                        type="selection"
                        width="80"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        type="index"
                        width="60"
                        label="序号"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="项目名称"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name" size="mini">
                            </el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="price"
                        label="项目金额"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.price" size="mini">
                            </el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="200px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteXM(scope.$index)">删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="item">
                    <div class="label label-pic">
                        环境及门面:
                    </div>
                    <div class="pics">
                        <div class="pics-item" v-for="(item, index) in picList1" :key="index">
                            <img :src="item" mode="" @click="previewImg(index,picList1)"/>
                            <img src="../../../assets/images/icon15.png" mode="" class="close" @click="clearImg(index,1)"/>
                        </div>
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addImg1"
                            >
                            <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="item">
                    <div class="label label-pic">
                        经营资质：(<span>*</span>营业执照及从业证明)
                    </div>
                    <div class="pics">
                        <div class="pics-item" v-for="(item, index) in picList2" :key="index">
                            <img :src="item" mode="" @click="previewImg(index,picList2)"/>
                            <img src="../../../assets/images/icon15.png" mode="" class="close" @click="clearImg(index,2)"/>
                        </div>
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addImg2"
                            >
                            <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="item">
                    <div class="label label-pic">
                        经营项目：(<span>*</span>经营项目的图片)
                    </div>
                    <div class="pics">
                        <div class="pics-item" v-for="(item, index) in picList3" :key="index">
                            <img :src="item" mode="" @click="previewImg(index,picList3)"/>
                            <img src="../../../assets/images/icon15.png" mode="" class="close" @click="clearImg(index,3)"/>
                        </div>
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addImg3"
                            >
                            <el-button type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
                        </el-upload>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isUpdateDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateshop">确 定</el-button>
                </div>
            </div>
        </el-dialog>

       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            conditionData:{
                petShop:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[],
            addressList:[],
            options:regionData,
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{

        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                name:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
